
const initialState = {
    audits: [],
    surveys: [],
    survey_templates: [],
    audited_departments: [],
    audit_templates: [],
    findings: [],
    question: [],
    question_comments:[],
};

export default function assetReducer(state = initialState, action) {
    switch (action.type) {

        case "GET_AUDITS":

            return {
                ...state,
                audits: action.payload,
            };

        case "GET_AUDIT_TEMPLATES":
            //console.log("GET_AUDIT_TEMPLATES ", action)
            return {
                ...state,
                audit_templates: action.payload,
            };

        case "FINDINGS_BY_SURVEY_SET":
            ////console.log("GET_AUDIT_TEMPLATES ", action)
            return {
                ...state,
                findings: action.payload,
            };
        
        case "GET_SURVEYS":
            //console.log(" GET_SURVEYS ", action)
            return {
                ...state,
                surveys: action.payload,
            };

        case "GET_SURVEYS_TEMPLATE":
           
            return {
                ...state,
                survey_templates: action.payload,
            };

        case "GET_AUDIT_DEPARTMENTS":
            console.log(" GET_AUDIT_DEPARTMENTS ", action)
            return {
                ...state,
                audited_departments: action.payload,
            };

        case "GET_SURVEY_QUESTION_BY_ID":

            return {
                ...state,
                question: action.payload.data,
                question_comments:  action.payload.comments
            };

        default:
            return state;
    }
}